import React, { useEffect, useState } from 'react';
import { FoundationsButton } from '../../GenericComponents/button';
import Dialog from '../../GenericComponents/dialog';
import { SavedAttributes, SavedValues, useApproveSaveMutation, useAttributesValuesMutation, UserRole, UserSavedAttributes, UsersbyStatus } from '../../Redux/Admin_Tasks/userAccountSlice';
import { FoundationsGenericToaster } from '../../GenericComponents/FoundationsGenericToaster';
import HLServerSearchListDialog from '../../GenericComponents/hlServerSearchListDialog';
import { approveUsersCallback } from './approveUsersCallback';
interface EditProps {
  isOpen: boolean;
  userId?: string | null;
  userAttributeData?: {
    userAttributesFieldList?: Array<{ FieldKey: number; FieldName: string;[key: string]: any }>;
  };
  userByStatus?: UsersbyStatus;
  userRole: { userRolesData: UserRole[] };
  saveAttribute: SavedAttributes;
  userSavedAttributes: UserSavedAttributes[];
  onApproveSuccess: () => void;
  onClose: () => void;
}

const Edit: React.FC<EditProps> = ({
  isOpen,
  userAttributeData = { userAttributesFieldList: [] },
  userByStatus,
  userId,
  userRole = { userRolesData: [] },
  saveAttribute,
  onApproveSuccess,
  onClose,
}) => {

  const [fullName, setFullName] = useState('');
  const [emailAddress, setEmailAddress] = useState('');
  const [currentRole, setCurrentRole] = useState('');
  const [isSearchVisible, setIsSearchVisible] = useState(false);
  const [selectedFieldKey, setSelectedFieldKey] = useState<number | null>(null); // Fix the type here
  const [selectedValue, setSelectedValue] = useState<string | undefined>();
  const [selectedKeyValue, setselectedKeyValue] = useState<number | null | undefined>(undefined);
  const [savedValues, setSavedValues] = useState<SavedValues>({});
  const userAttributesFieldList = userAttributeData?.userAttributesFieldList || [];
  const userSavedAttributes = saveAttribute?.userSavedAttributes || [];
  const [userSavedAttributesState, setUserSavedAttributesState] = useState<UserSavedAttributes[]>(userSavedAttributes);
  const [listid, setListid] = useState<number>();
  const [filterText, setFilterText] = useState<string>('');
  const [apiResponse, setApiResponse] = useState<any>(null);
  const [availableItems, setAvailableItems] = useState<any[]>([]);
  const [prevSelectedItems, setPrevSelectedItems] = useState<any[]>([]);
  const [hasUserSavedAttr, sethasUserSavedAttr] = useState(false);
  const [comment, setComment] = useState('');
  const [isApproved, setIsApproved] = useState(false); // State to track the checkbox
  const [fetchapproveSave, { data: approveSave, error: approveSaveError, isLoading: approveSaveLoading }] = useApproveSaveMutation();
  const [fetchUserAttributeValues, { data: userAttributeValues, error: userAttributeValuesError, isLoading: userAttributeValuesLoading }] =
    useAttributesValuesMutation();
  const [nationalProviderID, setNationalProviderID] = useState('');

  useEffect(() => {
    if (userByStatus?.usersData) {
      const user = userByStatus.usersData.find((user) => String(user.Id) === String(userId));
      if (user) {
        setFullName(user.FullName || '');
        setEmailAddress(user.EmailAddress || '');
        setCurrentRole(user.PrimaryRole.Id || '');
      }
    }
  }, [userByStatus, userId]);

  const handleSave = (selectedItems: any[]) => {
    if (selectedFieldKey !== null && selectedFieldKey !== undefined) {
      // Update savedValues
      let updatedSavedValues = { ...savedValues };
      
      // If selectedItems is empty, remove this field from savedValues
      if (selectedItems.length === 0) {
        delete updatedSavedValues[selectedFieldKey];
      } else {
        updatedSavedValues[selectedFieldKey] = selectedItems;
      }
      setSavedValues(updatedSavedValues);
  
      // Handle userSavedAttributesState updates properly
      // First, find if this attribute already exists
      const existingIndex = userSavedAttributesState.findIndex(
        attr => attr.MetaDataId === selectedFieldKey
      );
      
      // Create a copy of the current state
      let updatedUserSavedAttributesState = [...userSavedAttributesState];
      
      // If selectedItems is empty, remove this attribute if it exists
      if (selectedItems.length === 0) {
        if (existingIndex !== -1) {
          // Remove the attribute
          updatedUserSavedAttributesState.splice(existingIndex, 1);
        }
      } else {
        // Create the attribute object
        const displaytextandkeyset = selectedItems.map(item => ({ 
          KeyValue: item.KeyValue, 
          DisplayText: item.DisplayText 
        }));
        
        const attributeObject = {
          MetaDataId: selectedFieldKey,
          KeyValues: selectedItems.map(item => item.KeyValue),
          DisplayText: '',
          displaytextandkeyset: displaytextandkeyset
        };
        
        // If attribute exists, update it; otherwise add it
        if (existingIndex !== -1) {
          updatedUserSavedAttributesState[existingIndex] = attributeObject;
        } else {
          updatedUserSavedAttributesState.push(attributeObject);
        }
      }
      // Update the state
      setUserSavedAttributesState(updatedUserSavedAttributesState);
      // Update prevSelectedItems
      const updatedPrevItems = prevSelectedItems.filter(
        item => item.MetaDataId !== selectedFieldKey
      );
      
      // Only add items back if there are selected items
      if (selectedItems.length > 0) {
        selectedItems.forEach(item => {
          updatedPrevItems.push({
            ...item,
            MetaDataId: selectedFieldKey
          });
        });
      }
      
      setPrevSelectedItems(updatedPrevItems);
      setIsSearchVisible(false);
    } else {
      console.error('selectedFieldKey is null or undefined');
    }
  };

  const handleOpenSearch = (fieldKey: number) => {
    setSelectedFieldKey(fieldKey);
    // Get any existing selected items for this field from savedValues
    let selectedItems = [];
    if (savedValues[fieldKey]) {
      // If we have saved values for this field, use them
      selectedItems = savedValues[fieldKey].map(item => ({
        KeyValue: item.KeyValue,
        DisplayText: item.DisplayText,
        MetaDataId: fieldKey
      }));
    } else {
      // Otherwise check if there are any saved attributes from the original data
      const matchingAttribute = userSavedAttributesState.find(
        (attr) => attr.MetaDataId === fieldKey
      );
      if (matchingAttribute?.displaytextandkeyset && matchingAttribute.displaytextandkeyset.length > 0) {
        selectedItems = matchingAttribute.displaytextandkeyset.map((item: any) => ({
          KeyValue: Number(item.KeyValue),
          DisplayText: item.DisplayText,
          MetaDataId: fieldKey
        }));
      }
    }

    // Set the previously selected items
    setPrevSelectedItems(selectedItems);

    // Fetch available items for search
    if (fieldKey !== undefined && fieldKey !== null) {
      const requestData = {
        listname: 'emptyList',
        listid: fieldKey,
        filtertext: filterText,
      };

      fetchUserAttributeValues(requestData)
        .unwrap()
        .then((response) => {
          const data = response?.userAttributesValueList?.ValueList?.map((item: any) => ({
            KeyValue: item.KeyValue,
            DisplayText: item.DisplayText,
            DisplayDesc: item.DisplayDesc,
            MetaDataId: fieldKey
          })) || [];

          setAvailableItems(data);
          setIsSearchVisible(true);
        })
        .catch((apiError) => {
          console.error('API Error:', apiError);
          setAvailableItems([]);
          setIsSearchVisible(false);
        });
    }
  };

  const handleCloseSearch = () => {
    setIsSearchVisible(!isSearchVisible);
  };

  const handleSaveChanges = async () => {
    const allAttributes = userSavedAttributesState.map(attribute => ({
      metaDataId: attribute.MetaDataId,
      KeyValues: attribute.KeyValues,
      managerAttribute: false,
      showInUserSettings: true
    }));
    const dataToSave = {
      userId: userId != null ? Number(userId) : 0,
      fullName: fullName,
      email: emailAddress,
      roleId: currentRole ? Number(currentRole) : 0,
      groupId: 0,
      nationalProviderID: '',
      organizationName: '',
      makePowerUser: false,
      allowDataExport: false,
      allowPatientLookup: false,
      allowDataFix: false,
      allowUserNote: false,
      allowActivePanel: false,
      providerId: 0,
      comment: comment,
      userNewStatus: isApproved ? 3 : 1, // Set status based on isApproved
      attributes: allAttributes
    };
    
    try {
      await fetchapproveSave(dataToSave).unwrap();
      const message = `User account: ${fullName.toUpperCase()} has been updated successfully.`;
      FoundationsGenericToaster('success', message);
      
      // Only call onApproveSuccess if the user was actually approved
      if (isApproved) {
        onApproveSuccess();
      }
      onClose();
    } catch (error) {
      FoundationsGenericToaster('error', `Error updating user account: <strong>${fullName}</strong>.`);
    }
  };


  useEffect(() => {
    if (!isOpen) {
      // Reset state when the dialog is closed
      setSavedValues({});
      setPrevSelectedItems([]);
      setSelectedFieldKey(null);
      setIsApproved(false);
    }
  }, [isOpen]);

  return (
    <>
      <Dialog
        isOpen={isOpen}
        title="Edit User Account"
        width={840}
        height="auto"
        zIndex={101}
        onClose={onClose}
        buttons = {[
          {
              label: "Cancel",
              id: "cancelButton",
              onClick: onClose,
              className: "ui-button ui-corner-all ui-widget app-button negative",
          },
          {
              label: "Save Changes",
              id: "saveButton",
              onClick: handleSaveChanges,
              className: "ui-button ui-corner-all ui-widget app-button",
          },
        ]}
      >
        <div id="edit_user_dialog_wrapper" className="ui-dialog-content ui-widget-content">
          <div className="users-edit-dialog">
            <table id="table_edit_user_account" className="input-form-table-popup-window" style={{ width: '100%' }}>
              <tbody>
                <tr>
                  <td className="left" style={{ width: '310px' }}>
                    <div>Name:</div>
                  </td>
                  <td className="right">
                    <div id="label_edit_user_fullname" className="strong">{fullName}</div>
                  </td>
                </tr>
                <tr>
                  <td className="left">
                    <div>Email:</div>
                  </td>
                  <td className="right">
                    <div id="label_edit_user_email" className="strong">{emailAddress}</div>
                  </td>
                </tr>
                <tr>
                  <td className="left">
                    <div>Primary Role:</div>
                  </td>
                  <td className="right">
                    <select
                      id="select_edit_user_role"
                      value={currentRole}
                      onChange={(e) => setCurrentRole(e.target.value)}
                      style={{ width: '80%' }}
                    >
                      {userRole.userRolesData.length > 0 ? (
                        userRole.userRolesData.map((role) => (
                          <option key={role.Id} value={role.Id}>
                            {role.Name}
                          </option>
                        ))
                      ) : (
                        <option value="">No roles available</option>
                      )}
                    </select>
                  </td>
                </tr>
                <tr>
                  <td className="left">
                    <div>National Provider ID:</div>
                    <div className="field-optional">(optional)&nbsp;</div>
                  </td>
                  <td className="right">
                    <input
                      type="text"
                      id="text_edit_user_national_providerid"
                      value={nationalProviderID}
                      onChange={(e) => setNationalProviderID(e.target.value)}
                      maxLength={10}
                      style={{ width: '50%' }}
                    />
                  </td>
                </tr>
                {userAttributesFieldList.length > 0 &&
                  userAttributesFieldList.map((field) => {
                    const matchingAttribute = userSavedAttributesState.find(
                      (attr) => attr.MetaDataId === field.FieldKey
                    );

                    let displayText = '- not mapped -';

                    // Check if we have a matching attribute
                    if (matchingAttribute) {
                      // If we have saved values for this field
                      if (savedValues[field.FieldKey]) {
                        // Use the saved values directly since they're the most up-to-date
                        displayText = savedValues[field.FieldKey]
                          .map(item => item.DisplayText)
                          .join(', ');
                      }
                      // If no saved values but we have displaytextandkeyset from original data
                      else if (matchingAttribute.displaytextandkeyset && matchingAttribute.displaytextandkeyset.length > 0) 
                      {
                        displayText = matchingAttribute.displaytextandkeyset
                          .map((item: any) => item.DisplayText)
                          .join(', ');
                      }
                    }

                    return (
                      <tr
                        key={field.FieldKey}
                        id={`tr_userAttribute_${field.FieldKey}`}
                        className="users-edit-attribute-row-data"
                      >
                        <td className="left">
                          <div>{field.FieldName}:</div>
                          <div className="field-optional">(optional)&nbsp;</div>
                        </td>
                        <td className="right">
                          <input
                            type="text"
                            id={`input_userAttribute_${field.FieldKey}`}
                            className="hl-ui-editable hl-ui-editable-container"
                            placeholder={displayText !== '- not mapped -' ? displayText : ' - not mapped -'}
                            aria-label={`Input field for ${field.FieldName}`}
                            onClick={() => handleOpenSearch(field.FieldKey)}
                            value=""
                            readOnly={true}
                          />
                        </td>
                      </tr>
                    );
                  })}
              </tbody>
            </table>
          </div>
        </div>
      </Dialog>

      <HLServerSearchListDialog
        isOpen={isSearchVisible}
        elementObj={prevSelectedItems}
        onClose={handleCloseSearch}
        callbacks={approveUsersCallback(availableItems, handleSave)}
      />
    </>
  );
}

export default Edit;